"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var useTableData_1 = require("./useTableData");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var Prizes = function (_a) {
    var rewards = _a.rewards;
    var tableData = (0, useTableData_1.useTableData)(rewards);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.tableContainer, " ").concat(styles_module_scss_1.default.prizes) },
        react_1.default.createElement(ui_components_1.DataTable, { data: tableData, lazy: false })));
};
exports.default = Prizes;
